<script>
export default {}
</script>

<template>
  <div>
    <v-img
      :src="require('@assets/images/success.png')"
      contain
      aspect-ratio="1.5"
      width="200"
      class="ma-auto"
    />
    <p class="white--text font-weight-bold mt-10 mb-3">
      {{ $t('confirmResendQr') }}</p
    >
  </div>
</template>

<style lang="scss">
@import '@design';
</style>
